import React from 'react';
import styled, { css } from 'styled-components';
import { ColDiv, RowDiv, Text } from 'styles';
import { hexToRGB } from 'utils';
import { Icon } from 'components/common/Icon';

export function Input({ onChange, type, inputType, placeholder, maxLength, value, name, del, delClick, disabled, ...props }) {
  // const onChangeHandler = (event) => {
  //   const { name, value } = event.target;
  //   const valueMaxLength = maxLength === 0 || maxLength ? value.substring(0, maxLength) : value;
  //   const valueTemp = inputType === 'tel' ? valueMaxLength.replaceAll(/\D/g, '') : valueMaxLength;

  //   onChange(valueTemp, name);
  // };

  return (
    <InputConatiner>
      <CustomInput name={name} value={value || ''} onChange={onChange} placeholder={placeholder} disabled={disabled} type={type} {...props} />
      {del && <Icon name="del" $width={18} $height={18} $padding="3px" onClick={delClick} />}
    </InputConatiner>
  );
}

export function InputFormik({ type, placeholder, className, ...props }) {
  return (
    <InputConatiner>
      <CustomInput
        type={type || 'text'}
        placeholder={placeholder || ''}
        className={className}
        {...props}
      />
    </InputConatiner>
  );
}

const InputConatiner = styled(RowDiv)`
  position: relative;
  align-items: center;

  & > span {
    position: absolute;
    right: 0;
    cursor: pointer;
  }
`;

const CustomInput = styled.input`
  width: 100%;
  transition: all 150ms;
  background-color: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lighter};
  padding: 16px 24px;
  font-size: 1rem;
  line-height: 1.5;

  &:placeholder,
  &:disabled {
    color: rgba(23, 23, 23, 0.4);
  }

  @media ${({ theme }) => theme.device.mobile} {
    ${({ name }) =>
      name === 'testFile' &&
      css`
        font-size: 0.688rem;
        padding: 11px 24px 11px 8px;
      `};
  }
`;

export function FileInput2({ id, name, onChange, accetp, disabled, label, desc }) {
  return (
    <FileLabel htmlFor={id}>
      <LabelBox>
        <p>{label}</p>
      </LabelBox>
      <input type="file" accept={accetp || 'image/*'} name={name} onChange={onChange} id={id} disabled={disabled} />
      {desc && (
        <Text $type="b7" $mType="b8" $color={hexToRGB('#171717', 0.4)}>
          {desc}
        </Text>
      )}
    </FileLabel>
  );
}

export function FileInput({ values, setValues, accetp, disabled, label, desc }) {
  const saveFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setValues({ ...values, fileName: e.target.files[0].name });
    };
  };

  return (
    <FileLabel htmlFor="fileUpload">
      <LabelBox>
        <p>{label}</p>
      </LabelBox>
      <input type="file" accept={accetp || 'image/*'} onChange={saveFile} id="fileUpload" disabled={disabled} />
      {desc && (
        <Text $type="b7" $mType="b8" $color={hexToRGB('#171717', 0.4)}>
          {desc}
        </Text>
      )}
    </FileLabel>
  );
}

const FileLabel = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 16px;

  & > input {
    display: none;
  }
`;

const LabelBox = styled(ColDiv)`
  width: 89px;
  height: 33px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid rgba(23, 23, 23, 0.12);

  & > p {
    font-size: 0.688rem;
    font-weight: 500;
    line-height: 1;
  }
`;
